import { createColumns } from "@/lib/table/columnFactory";
import { actionsColumnFactory, type LeaveRequestActions } from "./actions";
import { dureeColumn } from "./duree";
import { type DemandeAbsenceRow, getColumns, type HRAbsenceColumnsOptions } from "./factory";
import { periodeColumn } from "./periode";
import { statutColumn } from "./statut";
import { typeColumn } from "./type";
import type { LeaveRequest } from "./types";

export type { LeaveRequestActions } from "./actions";
export type { DemandeAbsenceRow, HRAbsenceColumnsOptions } from "./factory";
export type { LeaveRequest } from "./types";

export const congesRequestsColumns = createColumns<LeaveRequest>([
  typeColumn,
  periodeColumn,
  dureeColumn,
  statutColumn,
]);

export function getCongesRequestsColumns(actions: LeaveRequestActions) {
  return createColumns<LeaveRequest>([
    typeColumn,
    periodeColumn,
    dureeColumn,
    statutColumn,
    actionsColumnFactory(actions),
  ]);
}

export { getColumns } from "./factory";
